"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);

// The account view an Owner or IT person's Account page needs; member locks
// come from the org page's own GetAccount.
const toView = (a) => ({
  Flagged: true,
  SubscriptionKey: a.SubscriptionKey,
  DefaultOrgKey: a.DefaultOrgKey,
  OrgKeys: a.OrgKeys,
  MyRole: a.MyRole,
  SettingsConfigured: a.SettingsConfigured,
  AuditLog: a.AuditLog,
  MemberLocks: {},
})

/* The flagged accounts the signed-in user manages (ListMyAccounts), kept
 * for the session so Settings has them on its first paint (F-3). The app
 * shell starts the load at sign-in; Settings asks again on each visit and
 * shows what it has meanwhile. Kept per user, so a later sign-in never sees
 * an earlier user's accounts. */
let cached = null
let inFlight = null
const listeners = new Set()

 const subscribeMyAccounts = (listener) => {
  listeners.add(listener)
  return () => { listeners.delete(listener) }
}; exports.subscribeMyAccounts = subscribeMyAccounts

 const getCachedMyAccounts = (userKey) =>
  userKey && _optionalChain([cached, 'optionalAccess', _ => _.userKey]) === userKey ? cached.accounts : undefined; exports.getCachedMyAccounts = getCachedMyAccounts

// One request per user at a time; the answer replaces the cached list.
 const loadMyAccounts = (userKey) => {
  if (_optionalChain([inFlight, 'optionalAccess', _2 => _2.userKey]) === userKey) return inFlight.promise
  const promise = _actions2.default.listMyAccounts()
    .then(r => {
      const accounts = (_nullishCoalesce(_optionalChain([r, 'optionalAccess', _3 => _3.Accounts]), () => ( []))).map(toView)
      cached = { userKey, accounts }
      listeners.forEach(l => l())
      return accounts
    })
    .finally(() => { if (_optionalChain([inFlight, 'optionalAccess', _4 => _4.promise]) === promise) inFlight = null })
  inFlight = { userKey, promise }
  return promise
}; exports.loadMyAccounts = loadMyAccounts
